import { ConnectButton } from '@rainbow-me/rainbowkit'
import { useAccount } from 'wagmi'
import { useUser } from '../../../context'
import { useState } from 'react'
import { DepositModal } from '../../../components'
import { WithdrawalModal } from '../../../components/WithdrawModal'

export const TopHeaders = () => {
	const { user } = useUser()
	const { address, isConnected } = useAccount()
	const [depositPanelOpen, setDepositPanelOpen] = useState(false)
	const [withdrawPanelOpen, setWithdrawPanelOpen] = useState(false)

	return (
		<div className="main-functions">
			<div className="welcome">
				<span className="title">Welcome, {user?.dbInfo?.name} 👋</span>
				<span className="subtitle">
					Your portfolio is performing well today.
				</span>
			</div>

			<div className="flex-row">
				{isConnected ? (
					<div className="flex-row">
						<button
							className="theme-yellow-button"
							onClick={() => {
								setDepositPanelOpen(true)
							}}
						>
							Deposit
						</button>
						<div
							style={{
								width: 10,
							}}
						/>
						<button
							className="theme-yellow-button"
							onClick={() => {
								setWithdrawPanelOpen(true)
							}}
						>
							Withdraw
						</button>
					</div>
				) : (
					<ConnectButton />
				)}
			</div>
			<DepositModal
				qrCodeAddress={user?.dbInfo?.address || ''}
				isOpen={depositPanelOpen}
				onRequestClose={() => {
					setDepositPanelOpen(false)
				}}
			/>
			<WithdrawalModal
				isOpen={withdrawPanelOpen}
				onRequestClose={() => {
					setWithdrawPanelOpen(false)
				}}
			/>
		</div>
	)
}
